/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data: {
        data: [],
        //分页数据
        selector: '.list',
        api: 'getUserCommentList',
        param: {
            user_id: qk_author.author_id,
            size: 10
        },
        isDataEmpty:false,
        loading: true,
        locked:false,
    },
    mounted() {
        // 加载数据
        this.loadData();
    },
    methods: {
        // 加载数据
        loadData() {
            this.$nextTick(() => {
                this.$refs.jsonPageNav.load(1, '', true);
            });
        },
        // 接收子组件的传值
        change(data) {
            //this.data = [];
            this.data.push(...data.data);
            this.isDataEmpty = (this.data.length === 0);
            this.loading = !this.loading;
            this.$nextTick(() => {
                //listFadein(document.querySelectorAll('.comments-page .comments-list > li'),10)
            });
            
        },
    }
};
